import axios from "axios";
import Config from "src/config";

const v2_actionMetaWhatsappEnviarTemplate = (querys, data) => {
    let url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chats/canais/enviar-template${querys}`;
    return axios({
        method: "post",
        url:url,
        data
    });
};

export default v2_actionMetaWhatsappEnviarTemplate;
